/**
 * Checks if the given value is a valid hexadecimal color code.
 *
 * @param {string} value - The value to be checked.
 * @return {boolean} Returns true if the value is a valid hexadecimal color code, false otherwise.
 */
export function isValidHexValue(value: string) {
  return /^#[A-Fa-f0-9]{6}$/.test(value);
}
